import React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import CategoryProductList from '../components/CategoryProductList';
import ModularBlocks from '../components/ModularBlocks';
import { getSchemaDescription } from '../utils';

const ShopPage = ({
  data: {
    datoCmsShop: { seoMetaTags, title, modularBlocks },
    inStockProducts,
    giftCardProduct,
    continueSellingProducts,
    outOfStockProducts,
  },
}) => {
  const mergedAvailableProducts = [
    ...inStockProducts.nodes,
    ...continueSellingProducts.nodes,
  ].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return (
    <Layout title={title} description={getSchemaDescription(seoMetaTags)}>
      <HelmetDatoCms seo={seoMetaTags} />
      <main>
        <PageHeader heading={title} />
        <CategoryProductList
          items={[
            ...mergedAvailableProducts,
            giftCardProduct,
            ...outOfStockProducts.nodes,
          ]}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export const ShopPageQuery = graphql`
  query ShopPageQuery {
    datoCmsShop {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      modularBlocks {
        ...ContentModularBlockFragment
      }
    }
    inStockProducts: allShopifyProduct(
      filter: { totalInventory: { gt: 0 } }
      sort: { fields: updatedAt, order: DESC }
    ) {
      nodes {
        ...ProductCardFragment
      }
    }
    giftCardProduct: shopifyProduct(isGiftCard: { eq: true }) {
      ...ProductCardFragment
    }
    continueSellingProducts: allShopifyProduct(
      filter: {
        totalInventory: { eq: 0 }
        variants: { elemMatch: { inventoryPolicy: { eq: CONTINUE } } }
      }
      sort: { fields: updatedAt, order: DESC }
    ) {
      nodes {
        ...ProductCardFragment
      }
    }
    outOfStockProducts: allShopifyProduct(
      filter: {
        totalInventory: { eq: 0 }
        isGiftCard: { eq: false }
        variants: { elemMatch: { inventoryPolicy: { ne: CONTINUE } } }
      }
      sort: { fields: updatedAt, order: DESC }
    ) {
      nodes {
        ...ProductCardFragment
      }
    }
  }
`;

export default ShopPage;
